import React, { useState } from "react";
import logo from "../img/logo_branca.png";

export default function MenuSuperior() {
  const [open, setOpen] = useState(false);
  const usu_tipo = localStorage.getItem("usu_tipo");

  const Item = ({ href, children }) => (
    <a
      href={href}
      className="
        !no-underline hover:!no-underline focus:!no-underline active:!no-underline
        appearance-none
        !shadow-none !border-0

        no-underline
        text-white/90 hover:text-white
        text-[16px] font-semibold
        px-3 py-3
        w-full text-center
        rounded-md hover:bg-white/10
        transition
        text-white w-full shadow-none border-none
        md:w-auto md:text-left md:px-2 md:py-1 md:rounded-none md:hover:bg-transparent
      "
    >
      {children}
    </a>
  );

  return (
    <header className="bg-[linear-gradient(90deg,#007bff_0%,#66b2ff_100%)] text-white w-full">

      <div className="w-full px-4 md:px-8 h-[112px] flex items-center justify-between">

        {/* ESQUERDA (logo + menu juntos) */}
        <div className="flex items-center gap-6 w-full md:w-auto justify-center md:justify-start">

          {/* LOGO */}
          <img src={logo} alt="Logo" className="h-14 mx-auto md:mx-0 md:ml-5 " />

          {/* MENU DESKTOP (agora ao lado da logo) */}
          <nav className="bg-transparent hidden md:flex  ml-4 !shadow-none border-none appearance-none !no-underline hover:!no-underline focus:!no-underline active:!no-underline">

            <Item href="/metatimebabita">META 2026 #TIMEBABITA</Item>

            {usu_tipo === "1" && (
              <>
                <Item href="/metavendedoracliente">META VENDEDORA / REVENDEDORA</Item>
                <Item href="/metavendedorageralvend">META GERAL</Item>
              </>
            )}

            {usu_tipo === "2" && (
              <>
                <Item href="/metavendedorageralgerenteloja">META VENDEDORA / REVENDEDORA (GERENTE LOJA)  (G)</Item>
                <Item href="/metavendedorageralgerencial">META GERAL (GERENTE LOJA)</Item>
              </>
            )}

            {(usu_tipo === "0" || usu_tipo === "2") && (
              <Item href="/metavendedorageralgerencialNEW">META THINK! LOJAS</Item>
            )}

            {(usu_tipo === "1" || usu_tipo === "2") && (
              <>
                <Item href="/estoqueloja">ESTOQUE LOJA</Item>
                <Item href="/tipopagamentorealizado">TIPOS DE PAGAMENTO REVENDEDORA</Item>
              </>
            )}

            {(usu_tipo === "0" || usu_tipo === "2") && (
              <Item href="/ResetaSenhaRevendora">RESETA SENHA REVENDEDORA</Item>
            )}

            {usu_tipo === "0" && (
              <>
                <Item href="/tipopagamentorealizadoGeral">TIPOS DE PAGAMENTO REVENDEDORA</Item>
                <Item href="/estoquelogisticacomfoto">ESTOQUE LOGISTICA FOTO</Item>
              </>
            )}

            {usu_tipo === "3" && (
              <Item href="/estoquelogistica">ESTOQUE LOGISTICA</Item>
            )}

            {usu_tipo && <Item href="/alterarsenha">ALTERAR SENHA</Item>}
          </nav>
        </div>

        {/* DIREITA */}
        <div className="flex items-center gap-3">

          {/* SAIR DESKTOP */}
          <a
            href="/"
            className="hidden md:block text-white text-[18px] no-underline font-semibold px-3 py-1 rounded-md hover:bg-white/10 transition"
          >
            SAIR
          </a>

          {/* MENU MOBILE */}
          <button
            className="md:hidden text-white text-2xl"
            onClick={() => setOpen(!open)}
          >
            ☰
          </button>
        </div>
      </div>

      {/* MOBILE */}
      {open && (
        <div className=" md:hidden absolute top-[112px] left-0 w-full flex flex-col items-center gap-2 bg-[linear-gradient(90deg,#007bff_0%,#66b2ff_100%)] text-center py-4 z-50">

          <Item href="/metatimebabita">META 2026 #TIMEBABITA</Item>

          {usu_tipo === "1" && (
            <>
              <Item href="/metavendedoracliente">META VENDEDORA / REVENDEDORA</Item>
              <Item href="/metavendedorageralvend">META GERAL</Item>
            </>
          )}

          {usu_tipo === "2" && (
            <>
              <Item href="/metavendedorageralgerenteloja">META VENDEDORA / REVENDEDORA (GERENTE LOJA)</Item>
              <Item href="/metavendedorageralgerencial">META GERAL (GERENTE LOJA)</Item>
            </>
          )}

          {(usu_tipo === "0" || usu_tipo === "2") && (
            <Item href="/metavendedorageralgerencialNEW">META THINK! LOJAS</Item>
          )}

          {(usu_tipo === "1" || usu_tipo === "2") && (
            <>
              <Item href="/estoqueloja">ESTOQUE LOJA</Item>
              <Item href="/tipopagamentorealizado">TIPOS DE PAGAMENTO REVENDEDORA</Item>
            </>
          )}

          {(usu_tipo === "0" || usu_tipo === "2") && (
            <Item href="/ResetaSenhaRevendora">RESETA SENHA REVENDEDORA</Item>
          )}

          {usu_tipo === "0" && (
            <>
              <Item href="/tipopagamentorealizadoGeral">TIPOS DE PAGAMENTO GERAL</Item>
              <Item href="/estoquelogisticacomfoto">ESTOQUE LOGISTICA COM FOTO</Item>
            </>
          )}

          {usu_tipo === "3" && (
            <Item href="/estoquelogistica">ESTOQUE LOGISTICA</Item>
          )}

          {usu_tipo && <Item href="/alterarsenha">ALTERAR SENHA</Item>}

          {/* SAIR CENTRAL */}
          <a
            href="/"
            className="mt-3 w-full max-w-[200px] text-[18px] text-white/90 hover:text-white no-underline font-semibold text-center border-none py-2 rounded-md hover:bg-white/10"
          >
            SAIR
          </a>
        </div>
      )}
    </header>
  );
}